export default __webpack_public_path__ + "static/media/pin.667923b6.svg";